document.addEventListener('DOMContentLoaded', () => {
	const categoryLinks = document.querySelectorAll('.menu-title a, .mobile-menu-item a');
	const mobileMenuItems = document.querySelectorAll('.mobile-menu-item');
	const secondaryMenuItems = document.querySelectorAll('.header__secondary-nav .category-link');
  
	// Check if we're in Shopify theme editor
	const isThemeEditor = window.Shopify && Shopify.designMode;
  
	// Set cookie
	const setCookie = (name, value, days) => {
	  const expires = days
		? `; expires=${new Date(Date.now() + days * 86400000).toUTCString()}`
		: '';
	  document.cookie = `${name}=${value}; path=/${expires}`;
	};
  
	// Get cookie
	const getCookie = name =>
	  document.cookie
		.split(';')
		.map(c => c.trim())
		.find(c => c.startsWith(name + '='))?.substring(name.length + 1) || null;
  
	// Helper functions to save and load the category from the proper storage
	const saveCategory = category => {
	  if (isThemeEditor) {
		localStorage.setItem('selectedCategory', category);
	  } else {
		setCookie('selectedCategory', category, 30);
	  }
	};
  
	const loadCategory = () =>
	  isThemeEditor ? localStorage.getItem('selectedCategory') : getCookie('selectedCategory');
  
	/* DO NOT REFACTOR */
	// Anti-flickering function
	function filterDesktopCategories(selectedCategory) {
	  document.querySelectorAll('.category-group').forEach((group) => {
		let groupCategory = group.getAttribute('data-category');
		selectedCategory = isNaN(selectedCategory) ? selectedCategory : Number(selectedCategory);
		groupCategory = isNaN(groupCategory) ? groupCategory : Number(groupCategory);
  
		if (groupCategory == selectedCategory) {
			if (group.classList.contains('footer-category-group')) {
			  group.style.display = 'grid';
			} else {
			  group.style.display = 'flex';
			}
		  group.style.visibility = 'visible';
		  setTimeout(() => {
			group.style.opacity = '1'; // Fade in
		  }, 50);
		} else {
		  group.style.opacity = '0'; // Fade out
		  setTimeout(() => {
			group.style.display = 'none';
			group.style.visibility = 'hidden';
		  }, 100);
		}
	  });
	}
  
	const filterMobileCategories = selectedCategory => {
	  document.querySelectorAll('.category-group-mobile').forEach(group => {
		let groupCategory = group.getAttribute('data-category');
		selectedCategory = isNaN(selectedCategory) ? selectedCategory : Number(selectedCategory);
		groupCategory = isNaN(groupCategory) ? groupCategory : Number(groupCategory);
		group.style.display = groupCategory == selectedCategory ? 'grid' : 'none';
	  });
	};
  
	const highlightSelectedCategory = selectedCategory => {
	  mobileMenuItems.forEach(item =>
		item.classList.toggle('selected', item.getAttribute('data-menu') === selectedCategory)
	  );
	};
  
	const highlightSecondaryMenu = selectedCategory => {
	  secondaryMenuItems.forEach(item =>
		item.classList.toggle('selected', item.getAttribute('data-category') === selectedCategory)
	  );
	};
  
	// Consolidated function to update the category
	const updateCategory = selectedCategory => {
	  if (!selectedCategory) return;
	  saveCategory(selectedCategory);
	  filterDesktopCategories(selectedCategory);
	  filterMobileCategories(selectedCategory);
	  highlightSelectedCategory(selectedCategory);
	  highlightSecondaryMenu(selectedCategory);
	};
  
	let savedCategory = loadCategory();
  
	if (typeof window.productSKU === 'string') {
	  const skuPrefix = window.productSKU.substring(0, 2).toUpperCase();
	  savedCategory = skuPrefix === 'N1' ? 'miehet' : skuPrefix === 'N2' ? 'naiset' : 'naiset';
	  saveCategory(savedCategory);
	}
  
	if (!savedCategory && categoryLinks.length) {
	  savedCategory = categoryLinks[0].getAttribute('data-category');
	  saveCategory(savedCategory);
	}
  
	if (savedCategory) {
	  console.log('Applying saved category:', savedCategory);
	  updateCategory(savedCategory);
	}
  
	categoryLinks.forEach(categoryLink => {
	  categoryLink.addEventListener('click', event => {
		const selectedCategory = categoryLink.getAttribute('data-category');
		if (!selectedCategory) return;
		
		// If it's an anchor link (#), update immediately
		if (categoryLink.getAttribute('href') === '#') {
		  event.preventDefault();
		  updateCategory(selectedCategory);
		} else {
		  // For navigation links, save category but let navigation happen first
		  // The menu will update after the new page loads
		  saveCategory(selectedCategory);
		}
	  });
	});
  });
  